// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../college-and-career-public/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".item-selected[data-v-9543b392]{color:#fff;background-color:#009845}.item-excluded[data-v-9543b392]{color:#fff;background-color:#a9a9a9}", ""]);
// Exports
module.exports = exports;
